import { environment as devEnvironment } from "./environment.dev";
import { environment as prodEnvironment } from "./environment.prod";

// Support both Vite and legacy environment variables
const nodeEnv = import.meta.env?.MODE || process.env.NODE_ENV;
const appEnv = import.meta.env?.VITE_APP_ENV || process.env.REACT_APP_ENV;

const environment: Environment =
  nodeEnv === "production" && appEnv === "production"
    ? prodEnvironment
    : devEnvironment;

export interface Environment {
  production: boolean;
  firebase: {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
  collections: {
    users: string;
    byotSearchHistory: string;
    plannedActivities: string;
    plannedFlights: string;
    plannedHotels: string;
    bookedFlights: string;
    bookedHotels: string;
    bookedManualActivities: string;
    bookedVendorActivities: string;
    trips: string;
  };
  stripePublicKey: string;
}

export { environment };
